import React from 'react';
import {appGetUrlPath} from '../function_lib/common_cms';
import './top_banner.css';
export function Top_Banner(lsData){
    var appPath=appGetUrlPath();
    var strResp="";
  //  alert(lsData.length);
    for(var i=0;i<lsData.length;i++){

 var stylBgImg="";
 if(lsData[i]["col4"]!==""){
     stylBgImg="style=\"background:url("+appPath+lsData[i]["col4"].trim()+") no-repeat;background-size:cover;background-position:center;height:300px\"";
 }       
strResp+="<div "+stylBgImg+" class=\"breadcrumb-area top-banner\">"+
           "<div class=\"container\">"+
            "<div class=\"row\">"+
                "<div class=\"col-12\">"+
                    // "<div class=\"row breadcrumb_box  align-items-center\">"+
                    //     "<div class=\"col-lg-6  col-md-6 col-sm-12\">"+
                    //         "<ul class=\"breadcrumb-list text-center text-md-right\">"+
                    //             "<li class=\"breadcrumb-item\"><a href=\""+lsData[i]["col2"]+"\">"+""+"</a\"></li>"+
                    //         "</ul>"+
                    //     "</div>"+
                    // "</div>"+
                "</div>"+
            "</div>"+
        "</div>"+
    "</div>";
    }
    //alert("testing=="+strResp);
    return strResp;
}
export default Top_Banner;